// Versi Refactored: ManagePosition (Multiple posList)
import { Card, Col, Form, Row } from 'antd';
import {
  ButtonBack,
  ButtonSubmit,
  ButtonAdd,
  ButtonAction,
} from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import { useAtom } from 'jotai';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useOrgRepo from 'services/repo/useOrgRepo';
import useDivRepo from 'services/repo/useDivisionRepo';
import useDeptRepo from 'services/repo/useDepartmentRepo';
import usePositionRepo from 'services/repo/usePositionRepo';
import useUserRepo from 'services/repo/useUserRepo';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import {
  dismissToast,
  errorToast,
  loadingToastId,
  successToast,
} from 'utils/Toast';
import {
  CustomFormItemSelectDropdown,
  CustomFormItemText,
  CustomFormItemInteger,
  CustomFormItemSwitch,
} from 'components/Common/CustomFormItem';
import { CustomAntdTableTemp } from 'components/Common/CustomAntdTableTemp';
import { INIT_POSITION, positionAtom } from 'store/Position/position';
import {
  setFieldValues,
} from 'utils/Helper';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';

export default function ManagePosition() {
  const { posId } = useParams();
  const navigate = useNavigate();
  useTopbarTitleHooks(`${posId ? 'Edit' : 'Create'} Position`);

  const { getOrgList } = useOrgRepo();
  const { getDivisionList } = useDivRepo();
  const { getDepartmentList } = useDeptRepo();
  const { isLoading: isLoadingSave, createPosition, updatePosition, getPositionById } = usePositionRepo(false);
  const { getUserList } = useUserRepo();
  const [form] = Form.useForm();
  const [orgOptions, setOrgOptions] = useState([]);
  const [divOptions, setDivOptions] = useState([]);
  const [deptOptions, setDeptOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([])
  const [dataField, setDataField] = useAtom(positionAtom);

  const [positionList, setPositionList] = useState([]);
  const isLoadingPrivilege = useRef(true);

  const [filters, setFilters] = useState({
    orgId: null,
    divId: null,
    deptId: null,
    posId: null,
    wfId: null
  })

  const [tableParams, setTableParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    filter: { ...filters },
    orderBy: "divName",
    isAscending: true
  });

  const fetchDataOrg = async () => {
    const payload = {
      pageNumber: 1,
      pageSize: 0,
      orderBy: "orgId",
      isAscending: true,
      filter: {
        orgId: null,
        orgName: "",
        status: "true",
      },
    }

    const res = await getOrgList(payload)
    if (res?.detail == 'OK' && res?.status === 200) {

      const options = res.data.content.map(item => ({
        label: item?.orgName,
        value: item?.orgId,
      }));
      setOrgOptions(options);

      if (options.length === 1) {
        const onlyOption = options[0];
        setDataField(prev => ({ ...prev, orgId: onlyOption.value }));

        form.setFieldsValue({ orgId: onlyOption.value }); // isinya harus { label, value }
        setFilters((prev) => ({ ...prev, orgId: onlyOption.value }));

        setTableParams((prev) => ({
          ...prev,
          filter: {
            ...prev.filter,
            orgId: onlyOption.value
          }
        }));
        fetchDataDivision(onlyOption.value);
      }
    }
  }

  const fetchDataDivision = async (orgId) => {
    const payload = {
      pageNumber: 1,
      pageSize: 0,
      filter: {
        divCode: "",
        divName: "",
        orgId: orgId,
        divId: null,
        status: "true",
      },
      orderBy: "divCode",
      isAscending: true
    }
    setDivOptions([])

    const res = await getDivisionList(payload)
    if (res?.detail == 'OK' && res?.status === 200) {
      setDivOptions(() => {
        return res?.data?.content.map(item => {
          return {
            value: item?.divId,
            label: item?.divName
          }
        })
      })
    }
  }

  const fetchDataDepartment = async (divId) => {
    const res = await getDepartmentList({ pageNumber: 1, pageSize: 0, filter: { divId, status: 'true' } });
    if (res?.detail === 'OK') {
      setDeptOptions(res.data.content.map(item => ({ label: item.deptName, value: item.deptId })));
    }
  };

  const fetchUserList = async () => {
    const res = await getUserList({ pageNumber: 1, pageSize: 0, filter: { status: 'true' } });
    if (res?.detail === 'OK') {
      setUserOptions(res.data.content.map(item => ({ label: item.userFullName, value: item.userId })));
    }
  };


  const fetchGetPositionById = async id => {
    const res = await getPositionById({ posId: id });
    if (res?.detail === 'OK') {
      const data = res.data;
      form.setFieldsValue({
        posCode: data.posCode,
        posName: data.posName,
        orgNameOption: data.orgId,
        divId: data.divId,
        deptNameOption: data.deptId,
        submissionUserIdOption: data.submissionUserId,
        approverUserIdOption: data.approverUserId,
        reviewerUserIdOption: data.reviewerUserId,
        posResourceTotal: data.posResourceTotal,
        status: String(data.status).toLowerCase() === 'true'
      });
      setDataField({ ...data });
      fetchDataDivision(data.orgId);
      fetchDataDepartment(data.divId);
    }
  };

  const handleAddPosition = () => {
    form.validateFields().then(() => {

      const newItem = {
        id: Date.now(),
        ...dataField,
        orgName: orgOptions.find(o => o.value === dataField.orgId)?.label || '',
        divName: divOptions.find(o => o.value === dataField.divId)?.label || '',
        deptName: deptOptions.find(o => o.value === dataField.deptId)?.label || '',
        submissionUserName: userOptions.find(u => u.value === dataField.submissionUserId)?.label || '',
        reviewerUserName: userOptions.find(u => u.value === dataField.reviewerUserId)?.label || '',
        approverUserName: userOptions.find(u => u.value === dataField.approverUserId)?.label || '',
      };

      setPositionList(prev => [...prev, newItem]);
      // setDataField({ ...INIT_POSITION, status: true });
      // form.resetFields(['posCode', 'posName']);
      // form.setFieldsValue({ status: true });
      setDataField(prev => ({
        ...prev,
        posCode: '',
        posName: '',
        posResourceTotal: null
      }));
      form.setFieldsValue({ posCode: '', posName: '', posResourceTotal: null });
    }).catch(() => errorToast(Constant.message.errorForm));
  };


  const handleFormSubmit = e => {
    e.preventDefault();
    CustomAlert.confirm({
      title: posId ? 'Update Position!' : 'Submit Position!',
      description: posId ? 'Are you sure you want to update this position?' : 'Are you sure you want to submit this data?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      type: 'primary',
      onConfirmButton: () => (posId ? doUpdate() : doSubmit())
    });
  };

  const doSubmit = async () => {
    // Reset form agar field yang belum di-Add tidak divalidasi
    form.resetFields();

    if (positionList.length === 0) {
      return errorToast('Please add at least one position.');
    }

    const orgId = positionList[0].orgId;
    const hasMixedOrg = positionList.some(item => item.orgId !== orgId);
    if (hasMixedOrg) return errorToast('All positions must belong to the same organization.');

    const payload = {
      orgId,
      posList: positionList.map(({ id, orgName, divName, deptName, submissionUserName, approverUserName, ...item }) => ({
        ...item,
        posResourceTotal: item.posResourceTotal === '' ? null : item.posResourceTotal,
      })),
    };

    loadingToastId(Constant.message.savingData, payload);
    const response = await createPosition(payload);
    dismissToast(payload);

    if (response?.detail === 'OK') {
      successToast(Constant.message.saveDataSuccess);
      navigate(`${APP_ROUTE_PREFIX}/${RouteConstant.organization.position.index}`, { replace: true });
    } else {
      errorToast(Constant.message.errorSave);
    }
  };


  const doUpdate = async () => {
    try {
      await form.validateFields();
    } catch {
      return errorToast(Constant.message.errorForm);
    }

    const values = form.getFieldsValue();
    const payload = {
      posId,
      posCode: values.posCode,
      posName: values.posName,
      orgId: values.orgNameOption,
      divId: values.divId,
      deptId: values.deptNameOption || null,
      submissionUserId: values.submissionUserIdOption,
      reviewerUserId: values.reviewerUserIdOption,
      approverUserId: values.approverUserIdOption,
      posResourceTotal: values.posResourceTotal,
      status: values.status,
    };

    loadingToastId(Constant.message.savingData, payload);
    const response = await updatePosition(payload);
    dismissToast(payload);

    if (response?.detail === 'OK') {
      successToast(Constant.message.saveDataSuccess);
      navigate(`${APP_ROUTE_PREFIX}/${RouteConstant.organization.position.index}`, { replace: true });
    } else errorToast(Constant.message.errorSave);
  };


  const columns = [
    { title: 'Organization', dataIndex: 'orgName' },
    { title: 'Division', dataIndex: 'divName' },
    { title: 'Department', dataIndex: 'deptName' },
    { title: 'Code', dataIndex: 'posCode' },
    { title: 'Name', dataIndex: 'posName' },
    { title: 'Submission User', dataIndex: 'submissionUserName' },
    { title: 'Reiewer User', dataIndex: 'reviewerUserName' },
    { title: 'Approver User', dataIndex: 'approverUserName' },
    { title: 'Total Resource', dataIndex: 'posResourceTotal' },

    {
      title: 'Status',
      dataIndex: 'status',
      render: val => (val ? 'Active' : 'Inactive'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, row) => (
        <ButtonAction buttons={['delete']} onDelete={() => setPositionList(prev => prev.filter(item => item.id !== row.id))} />
      ),
    },
  ];

  const fetchCheckPrivilege = async () => {
    loadingToastId(Constant.message.loading, PRIVILEGE_ID.handleAddPosition)
    dismissToast(PRIVILEGE_ID.handleAddPosition)
    if (posId) await fetchGetPositionById(posId)
    isLoadingPrivilege.current = false
  }

  useEffect(() => {
    fetchDataOrg();
    fetchUserList();

    if (posId) {
      fetchGetPositionById(posId);
      // Jika edit, maka pastikan list kosong
      setPositionList([]);
    } else {
      setDataField(INIT_POSITION); // ✅ akan bawa status = 'true'
      form.setFieldsValue({ status: true }); // ✅ sinkron dengan default
    }

    fetchCheckPrivilege()

  }, [posId]);

  return (
    <Card>
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        labelAlign="left"
      >
        <Row gutter={[16]}>
          <Col xs={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="orgId"
              label="Organization"
              showSearch
              value={dataField?.orgId}
              rules={[{ required: true }]}
              placeholder="Select Organization"
              loading={false}
              options={orgOptions}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }

              // onChange={(value) => {
              //   setFilters((prev) => ({
              //     ...prev,
              //     orgId: value || null,
              //     divId: null
              //   }));
              //   form.setFieldsValue({ divId: undefined });
              //   if (value) fetchDataDivision(value);
              //   else setDivOptions([]);
              // }}

              onChange={(value) => {
                // sinkronkan state global
                setDataField(prev => ({ ...prev, orgId: value || null, divId: null, deptId: null }));
                // sinkronkan form dan filter
                setFilters(prev => ({ ...prev, orgId: value || null, divId: null }));
                form.setFieldsValue({ divId: undefined, deptNameOption: undefined });
                value ? fetchDataDivision(value) : setDivOptions([]);
              }}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="divId"
              label="Division/Unit Kerja"
              showSearch={true}
              value={dataField?.divId}
              rules={[
                {
                  required: true,
                },
              ]}
              placeholder="Select Division"
              options={divOptions}
              onChange={(value) => {
                setDataField((prev) => ({
                  ...prev,
                  divId: value || null,
                  deptId: null, // reset department jika division berubah
                }));

                form.setFieldsValue({ deptNameOption: undefined }); // reset field di form
                if (value) {
                  fetchDataDepartment(value); // chaining
                } else {
                  setDeptOptions([]);
                }
              }}

            />
          </Col>

          <Col xs={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="deptNameOption"
              label="Department"
              showSearch
              value={dataField?.deptId}
              rules={[{ required: false }]}
              placeholder="Select Department"
              disabled={!dataField?.divId}
              options={deptOptions}
              onChange={value => setDataField(prev => ({ ...prev, deptId: value || null }))}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemText
              nameFormItem="posCode"
              label="Code"
              placeholder="Fill in Position Code"
              rules={[{ required: false }]}
              value={dataField?.posCode}
              onChange={e => setDataField(prev => ({ ...prev, posCode: e.target.value }))}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemText
              nameFormItem="posName"
              label="Name"
              placeholder="Fill in Position Name"
              rules={[{ required: true }]}
              value={dataField?.posName}
              onChange={e => setDataField(prev => ({ ...prev, posName: e.target.value }))}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="submissionUserIdOption"
              label="Submission User"
              showSearch
              value={dataField?.submissionUserId}
              rules={[{ required: true }]}
              options={userOptions}
              placeholder="Select Submission User"
              onChange={value => setDataField(prev => ({ ...prev, submissionUserId: value }))}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="reviewerUserIdOption"
              label="Reviewer User"
              showSearch
              value={dataField?.reviewerUserId}
              rules={[{ required: true }]}
              options={userOptions}
              placeholder="Select Reviewer User"
              onChange={value => setDataField(prev => ({ ...prev, reviewerUserId: value }))}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="approverUserIdOption"
              label="Approver User"
              showSearch
              value={dataField?.approverUserId}
              rules={[{ required: true }]}
              options={userOptions}
              placeholder="Select Approver User"
              onChange={value => setDataField(prev => ({ ...prev, approverUserId: value }))}
            />
          </Col>

          <Col span={24}>
            <CustomFormItemInteger
              nameFormItem="posResourceTotal"
              label="Total Resource"
              value={dataField?.posResourceTotal}
              onChange={(value) => setDataField(prev => ({ ...prev, posResourceTotal: value }))}
              rules={[{ required: true }]}
              min={1}
              max={1000}
              placeholder="Enter Total Resource"
            />
          </Col>

          <Col xs={24} sm={24} lg={12}>
            <CustomFormItemSwitch
              nameFormItem="status"
              label="Is Active"
              value={dataField?.status}
              onChange={checked => setDataField(prev => ({ ...prev, status: checked }))}
            />
          </Col>

          {!posId && (
            <>

              <Col span={24} offset={6}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <ButtonAdd className="button-custom btn-gray" buttonText="Add" onClick={handleAddPosition} />
                </div>
              </Col>

              <Col span={24}>
                <div style={{ marginTop: 24 }}>
                  <CustomAntdTableTemp columns={columns} dataSource={positionList} rowKey="id" pagination={false} />
                </div>
              </Col>
            </>
          )}

          <Col span={24} offset={6}>
            <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
              <ButtonBack onClick={() => navigate(`${APP_ROUTE_PREFIX}/${RouteConstant.organization.position.index}`)} />
              <ButtonSubmit
                onClick={handleFormSubmit}
                loading={isLoadingSave}
                disabled={
                  (!posId && positionList.length === 0) || isLoadingPrivilege.current || isLoadingSave
                } />
            </div>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}
